// extracted by mini-css-extract-plugin
export default {"datagrid-wrapper":"MUIDatagrid_datagrid-wrapper__TSeg8","datagrid":"MUIDatagrid_datagrid__ljuC2"};